import { render, staticRenderFns } from "./BMPayment.vue?vue&type=template&id=d248b260&"
import script from "./BMPayment.vue?vue&type=script&lang=js&"
export * from "./BMPayment.vue?vue&type=script&lang=js&"
import style0 from "./BMPayment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports